import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICommonFormMeta {
  idBank: FormInputMeta,
  nameBank: FormInputMeta,
  bin: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  agency: FormInputMeta,
  merchant: FormInputMeta,
  client: FormInputMeta,
  clientStatus: FormInputMeta,
  PAN: FormInputMeta,
  sequence: FormInputMeta,
  cardProduct: FormInputMeta,
  cardType: FormInputMeta,
  cardStatus: FormInputMeta,
  account: FormInputMeta,
  accountType: FormInputMeta,
  accountStatus: FormInputMeta,
  internetOrder: FormInputMeta,
  mailOrder: FormInputMeta,
  system: FormInputMeta,

  bank: FormInputMeta,
  binType: FormInputMeta,
  usageCode: FormInputMeta,
  transactionCode: FormInputMeta,
  feeType: FormInputMeta,
  requestType: FormInputMeta,
  sourceType: FormInputMeta,
  status: FormInputMeta,
  city: FormInputMeta,
  activity: FormInputMeta,

  schema: any;
}

const commonFormMeta = {} as ICommonFormMeta;

commonFormMeta.idBank = {
  name: 'idBank',
  type: 'text',
  label: 'ID Banque',
  placeholder: '',
  validation: yup.string().required(),
};

commonFormMeta.nameBank = {
  name: 'nameBank',
  type: 'text',
  label: 'Banque',
  placeholder: '',
  validation: yup.string().required(),
};
commonFormMeta.bin = {
  name: 'bin',
  type: 'text',
  label: 'Bin',
  placeholder: '',
  validation: yup.string().required(),
};
commonFormMeta.startDate = {
  name: "startDate",
  type: "date",
  label: "Date du",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

commonFormMeta.endDate = {
  name: "endDate",
  type: "date",
  label: "Au",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
commonFormMeta.agency = {
  name: 'agency',
  type: 'select',
  label: 'Agence',
  options:  [
    {
      label: 'Agence A',
      value: 'a'
    },
    {
      label: 'Agence B',
      value: 'b',
    },
    {
      label: 'Agence C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.merchant = {
  name: 'merchant',
  type: 'select',
  label: 'Commerçant',
  options:  [
    {
      label: 'Commerçant A',
      value: 'a'
    },
    {
      label: 'Commerçant B',
      value: 'b',
    },
    {
      label: 'Commerçant C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.client = {
  name: 'client',
  type: 'select',
  label: 'Client',
  options:  [
    {
      label: 'Client A',
      value: 'a'
    },
    {
      label: 'Client B',
      value: 'b',
    },
    {
      label: 'Client C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.clientStatus = {
  name: 'clientStatus',
  type: 'select',
  label: 'Statut Client',
  options:  [
    {
      label: 'Statut Client A',
      value: 'a'
    },
    {
      label: 'Statut Client B',
      value: 'b',
    },
    {
      label: 'Statut Client C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.PAN = {
  name: 'PAN',
  type: 'select',
  label: 'PAN',
  options:  [
    {
      label: 'PAN A',
      value: 'a'
    },
    {
      label: 'PAN B',
      value: 'b',
    },
    {
      label: 'PAN C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.cardProduct = {
  name: 'cardProduct',
  type: 'select',
  label: 'Produit carte',
  options:  [
    {
      label: 'Produit carte A',
      value: 'a'
    },
    {
      label: 'Produit carte B',
      value: 'b',
    },
    {
      label: 'Produit carte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.cardType = {
  name: 'cardType',
  type: 'select',
  label: 'Type carte',
  options:  [
    {
      label: 'Type carte A',
      value: 'a'
    },
    {
      label: 'Type carte B',
      value: 'b',
    },
    {
      label: 'Type carte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.cardStatus = {
  name: 'cardStatus',
  type: 'select',
  label: 'Statut carte',
  options:  [
    {
      label: 'Statut carte A',
      value: 'a'
    },
    {
      label: 'Statut carte B',
      value: 'b',
    },
    {
      label: 'Statut carte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.account = {
  name: 'account',
  type: 'select',
  label: 'Compte',
  options:  [
    {
      label: 'Compte A',
      value: 'a'
    },
    {
      label: 'Compte B',
      value: 'b',
    },
    {
      label: 'Compte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.accountType = {
  name: 'accountType',
  type: 'select',
  label: 'Type compte',
  options:  [
    {
      label: 'Type compte A',
      value: 'a'
    },
    {
      label: 'Type compte B',
      value: 'b',
    },
    {
      label: 'Type compte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.accountStatus = {
  name: 'accountStatus',
  type: 'select',
  label: 'Statut compte',
  options:  [
    {
      label: 'Statut compte A',
      value: 'a'
    },
    {
      label: 'Statut compte B',
      value: 'b',
    },
    {
      label: 'Statut compte C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.internetOrder = {
  name: 'internetOrder',
  type: 'select',
  label: 'Ordre internet',
  options:  [
    {
      label: 'Ordre internet A',
      value: 'a'
    },
    {
      label: 'Ordre internet B',
      value: 'b',
    },
    {
      label: 'Ordre internet C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.mailOrder = {
  name: 'mailOrder',
  type: 'select',
  label: 'Ordre mail',
  options:  [
    {
      label: 'Ordre mail A',
      value: 'a'
    },
    {
      label: 'Ordre mail B',
      value: 'b',
    },
    {
      label: 'Ordre mail C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};
commonFormMeta.system = {
  label: "Système",
  name: "system",
  type: 'select',
  options: [
    {
      label: 'system One',
      value: 'system1',
      selected: true,
    },
    {
      label: 'system two',
      value: 'system2',
    },
  ],
};




commonFormMeta.bank = {
  label: "Bank",
  name: "bank",
  type: 'select',
  options: [
    {
      label: 'bank One',
      value: 'bank1',
      selected: true,
    },
    {
      label: 'bank two',
      value: 'bank2',
    },
  ],
};

commonFormMeta.binType = {
  label: "BIN Type",
  name: "BINType",
  type: 'select',
  options: [
    {
      label: 'binType One',
      value: 'binType1',
      selected: true,
    },
    {
      label: 'binType two',
      value: 'binType2',
    },
    {
      label: 'binType Three',
      value: 'binType3',
    },
  ],
};

commonFormMeta.transactionCode = {
  label: "Transaction Code",
  name: "transactionCode",
  type: 'select',
  options: [
    {
      label: 'transactionCode One',
      value: 'transactionCode1',
      selected: true,
    },
    {
      label: 'transactionCode two',
      value: 'transactionCode2',
    },
  ],
};

commonFormMeta.usageCode = {
  label: "Usage Code",
  name: "usageCode",
  type: 'select',
  options: [
    {
      label: 'usageCode One',
      value: 'usageCode1',
      selected: true,
    },
    {
      label: 'usageCode two',
      value: 'usageCode2',
    },
  ],
};

commonFormMeta.feeType = {
  label: "Fee Type",
  name: "feeType",
  type: 'select',
  options: [
    {
      label: 'Fee Type 1',
      value: 'fee-type1',
      selected: true,
    },
    {
      label: 'Fee Type 2',
      value: 'fee-type2',
    },
    {
      label: 'Fee Type 3',
      value: 'fee-type3',
    },
  ],
};

commonFormMeta.requestType = {
  label: "Request Type",
  name: "requestType",
  type: 'select',
  options: [
    {
      label: 'Request Type 1',
      value: 'request-type1',
      selected: true,
    },
    {
      label: 'Request Type 2',
      value: 'request-type2',
    },
    {
      label: 'Request Type 3',
      value: 'request-type3',
    },
  ],
};
commonFormMeta.sourceType = {
  label: "Source Type",
  name: "sourceType",
  type: 'select',
  options: [
    {
      label: 'Source Type 1',
      value: 'source-type1',
      selected: true,
    },
    {
      label: 'Source Type 2',
      value: 'source-type2',
    },
    {
      label: 'Source Type 3',
      value: 'source-type3',
    },
  ],
};

commonFormMeta.status = {
  label: "Status",
  name: "status",
  type: 'select',
  options: [
    {
      label: 'Statut 1',
      value: 'statut1',
      selected: true,
    },
    {
      label: 'Statut 2',
      value: 'statut2',
    },
    {
      label: 'Statut 3',
      value: 'statut3',
    },
  ],
};

commonFormMeta.city = {
  name: "city",
  label: "Ville",
  type: 'select',
  options: [
    {
      label: 'Douala',
      value: 'douala',
      selected: true,
    },
    {
      label: 'Yaounde',
      value: 'yaounde',
    },
    {
      label: 'Bafoussam',
      value: 'bafoussam',
    },
  ],
};

commonFormMeta.activity = {
  name: "activity",
  label: "Activité",
  type: 'select',
  options: [
    {
      label: 'Activité A',
      value: 'a',
      selected: true,
    },
    {
      label: 'Activité B',
      value: 'b',
    },
    {
      label: 'Activité C',
      value: 'c',
    },
  ],
};

commonFormMeta.schema = yup.object().shape(getValidationSchema(commonFormMeta));

export default commonFormMeta;